import { createFileRoute } from "@tanstack/react-router";

import BackButton from "@/components/back-button";
import { TermsContent } from "@/routes/app/$role/setup/-steps/legal-agreements";

export const Route = createFileRoute("/static/_layout/terms")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="w-full px-4 md:px-12 lg:px-[140px] pb-[200px] flex flex-col gap-8">
      <BackButton />
      <div className="prose-legal max-w-[900px]">
        <TermsContent />
      </div>
    </div>
  );
}
